module.exports = __webpack_public_path__ + "media/images/sky-d245b5751069cb4b50ed224f6cf40761.png";